import {IComponentOptions, IFilterService, ILogService} from 'angular';
import {ApplicationPropertyRS} from '../../../admin/service/applicationPropertyRS.rest';
import {getTSAnlaufstelleTypeValues} from '../../../models/enums/TSAnlaufstelleType';
import {getKantonCodeList, TSKantonCode} from '../../../models/enums/TSKantonCode';
import {rolePrefix, TSRole} from '../../../models/enums/TSRole';
import TSAnlaufstelle from '../../../models/TSAnlaufstelle';
import TSGemeinde from '../../../models/TSGemeinde';
import AnlaufstelleUtil from '../../../utils/AnlaufstelleUtil';
import RoleUtilService from '../../service/RoleUtilService';
import IScope = angular.IScope;
import IWindowService = angular.IWindowService;
import ITranslateService = angular.translate.ITranslateService;

let template = require('./dv-anlaufstelle-list.html');
require('./dv-anlaufstelle-list.scss');

export class DVAnlaufstelleListComponentConfig implements IComponentOptions {
    transclude = false;

    bindings: any = {
        anlaufstellen: '=',
        itemsByPage: '<',
        onEdit: '&',
    };
    template = template;
    controller = DVAnlaufstelleListController;
    controllerAs = 'vm';
}

export class DVAnlaufstelleListController {

    itemsByPage: number;
    anlaufstellen: Array<TSAnlaufstelle> = []; //Liste die im Gui angezeigt wird
    pagination: any;
    onEdit: (paramObj: any) => void;
    selectedKanton: TSKantonCode;
    selectedAnlaufstelleType: string;
    vereinbarungValid: number = 0;

    static $inject: any[] = ['$filter', '$log', 'CONSTANTS', '$scope', 'RoleUtilService', '$window', '$translate', 'ApplicationPropertyRS'];

    /* @ngInject */
    constructor(private $filter: IFilterService, private $log: ILogService,
                private CONSTANTS: any, private $scope: IScope, private roleUtilService: RoleUtilService,
                private $window: IWindowService, private $translate: ITranslateService, private applicationPropertyRS: ApplicationPropertyRS,
    ) {
        this.initViewModel();
    }

    private initViewModel() {
    }

    $onInit() {
        this.applicationPropertyRS.getVereinbarungValidYears().then((response) => {
            this.vereinbarungValid = response;
        });
        this.anlaufstellen = this.anlaufstellen.filter(AnlaufstelleUtil.isNotImportiert);

    }

    public getFilterroles(): Array<TSRole> {
        return this.roleUtilService.getAllRolesButGesuchstellerArray();

    }

    editClicked(anlaufstelleToEdit: any, event: any) {
        this.onEdit({anlaufstelle: anlaufstelleToEdit, event: event});
    }

    public translateAktiv(inaktiv: boolean): string {
        return inaktiv ? (this.$translate.instant('INAKTIV')) : (this.$translate.instant('AKTIV'));

    }

    public translateRoles(roles: Array<TSRole>): string {
        let prefix = rolePrefix();
        return roles.map((element) => {
            return this.$translate.instant(prefix + TSRole[element])
        }).join(', ');

    }

    public translateRole(role: TSRole): string {
        let prefix = rolePrefix();
        return this.$translate.instant(prefix + TSRole[role])

    }

    public getColumnsNumber(): number {

        let element = angular.element('.dv-anlaufstelle-list .header-row').first();
        if (element) {
            return element.get(0).childElementCount;
        }
        //could not determine actual number, just returing an approximation
        return 12;
    }

    public getAnlaufstelleTypes() {
        return getTSAnlaufstelleTypeValues();
    }

    /**
     * Alle TSKantonCode fuer das Filterdropdown
     * @returns {Array<key: string; code: TSKantonCode>}
     */
    public getKantone(): { key: string; code: TSKantonCode }[] {
        let kantonCodes: TSKantonCode[] = getKantonCodeList();
        let kantonNamesAndCodes: {
            key: string
            code: TSKantonCode
        }[] = [];

        kantonCodes.forEach(code => {
            kantonNamesAndCodes.push({
                key: this.$translate.instant(code.toString()),
                code: code,
            });
        });

        kantonNamesAndCodes.sort((a, b) => a.code.toString().localeCompare(b.code.toString()));

        return kantonNamesAndCodes;
    }

    public getGemeinden(gemeinden: Array<TSGemeinde>): string {
        let val: string = '';
        gemeinden.forEach((gemeinde) => {
            val += gemeinde.name + '\n';
        });
        return val;
    }

    public isInvalidVereinbarung(row: TSAnlaufstelle): boolean {
        return row.isInvalidVereinbarung(this.vereinbarungValid);
    }

}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-anlaufstelle-list/dv-anlaufstelle-list.ts